import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { categories } from '../constants';
import { useGDPRBannerContext } from '../useGDPRBanner';
import { Item } from './Item';
import { Line } from './Line';
const FIELD_NAME = 'categories[]';
function useSelectionState() {
    const [selectionState, setSelectionState] = useState({
        [categories.ESSENTIAL]: false,
        [categories.ANALYTICAL]: false,
        [categories.MARKETING]: false,
    });
    function toggleSection(field) {
        return function $toggleSection() {
            return setSelectionState((prevState) => {
                return {
                    ...prevState,
                    [field]: !prevState[field],
                };
            });
        };
    }
    return {
        selectionState,
        toggleSection,
    };
}
export function CookieSelector({ content }) {
    const { state, toggleSelection } = useGDPRBannerContext();
    const { selectionState, toggleSection } = useSelectionState();
    return (_jsxs("div", { children: [_jsx(Line, {}), _jsx(Item, { name: FIELD_NAME, value: categories.ESSENTIAL, isOpen: selectionState.essential, onClick: toggleSection(categories.ESSENTIAL), isSelected: state.essential, content: content.essential }), _jsx(Line, {}), _jsx(Item, { name: FIELD_NAME, value: categories.ANALYTICAL, isOpen: selectionState.analytical, onClick: toggleSection(categories.ANALYTICAL), isSelected: state.analytical, onSelect: toggleSelection(categories.ANALYTICAL), content: content.analytical }), _jsx(Line, {}), _jsx(Item, { name: FIELD_NAME, value: categories.MARKETING, isOpen: selectionState.marketing, onClick: toggleSection(categories.MARKETING), isSelected: state.marketing, onSelect: toggleSelection(categories.MARKETING), content: content.marketing }), _jsx(Line, {})] }));
}
